import React from "react";
import { QuickStatusDot } from "./QuickStatusDot.jsx";

const BADGE_TONE = ["blue", "yellow", "green", "red", "neutral"];

/**
 * Full status badge per status-badge-contract.
 * @param {object} props
 * @param {"blue"|"yellow"|"green"|"red"|"neutral"} props.tone
 * @param {string} props.label
 * @param {string} [props.meaning]
 * @param {boolean} [props.showDot]
 * @param {string} [props.testId]
 */
export function StatusBadge({
  tone = "neutral",
  label,
  meaning,
  showDot = true,
  testId = "status-badge",
}) {
  const safeTone = BADGE_TONE.includes(tone) ? tone : "neutral";

  return (
    <span
      className={`cq-status-badge cq-status-badge--${safeTone}`}
      data-testid={testId}
      title={meaning || label}
    >
      {showDot ? (
        <QuickStatusDot
          statusTone={safeTone}
          statusKey={safeTone}
          label={label}
          accessibleLabel={meaning || label}
          size="sm"
          testId={`${testId}-dot`}
        />
      ) : null}
      <span>{label}</span>
    </span>
  );
}
